import { api } from './api';

export const newsService = {
    getNews: async (pageNumber = 1, pageSize = 100) => {
        return api.get(`/news/fb-posts?PageNumber=${pageNumber}&PageSize=${pageSize}`);
    },

    getNewsById: async (id) => {
        return api.get(`/news/fb/${id}`);
    },

    createNews: async (payload) => {
        // payload should be { longUserAccessToken: "string" }
        return api.post('/news/fb', payload);
    },

    syncNews: async () => {
        // This is the direct API call for the sync button. Adjust the route if 'intha API' refers to a different endpoint.
        return api.get('/news/save-fb-posts');
    },

    updateNews: async (id, payload) => {
        return api.post(`/news/fb/${id}`, payload);
    },

    deleteNews: async (id) => {
        return api.delete(`/news/fb/${id}`);
    },
};
